import BaseService from "./BaseService";

export default class FiesService extends BaseService {

  constructor(self) {
    super(self);
  }

  BaseAnaliticaFies(parameters) {
    return this.ExecutaFetch("/api/Fies/BaseAnaliticaFies", "POST", parameters);
  }

  ConsultarFiesAditamento(parameters) {
    return this.ExecutaFetch("/api/Fies/ConsultarFiesAditamento", "POST", parameters);
  }
}